// src/panel/SuperAdminPanel.jsx
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/SuperAdminPanel.css';
import api from "../../../api/api";
import dashboardIcon from '../icons/dashboard.png';
import logoutIcon from '../icons/logout.png';
import teacherIcon from '../icons/teacher.svg';
import studentIcon from '../icons/class.png';
import notificationIcon from '../icons/notification.png';
import modulesIcon from '../icons/modules.png';
const SuperAdminPanel = ({ onToggle, hideToggle = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const superAdminId = localStorage.getItem('userId');

  const handleNavigate = (path) => {
    setActivePath(path);
    navigate(path);
    if (window.innerWidth <= 768) {
      document.querySelector('.superadmin-panel').classList.remove('expanded');
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate(`/portal/superadmin`);
  };

  const toggleSidebar = () => {
    const panel = document.querySelector('.superadmin-panel');
    if (window.innerWidth <= 768) {
      panel.classList.toggle('expanded');
    } else {
      setIsCollapsed(!isCollapsed);
      if (onToggle) onToggle(!isCollapsed);
    }
  };

  return (
    <div className="superadmin-panel-wrapper">
      {!hideToggle && (
        <div
          className={`superadmin-toggle-button ${isCollapsed ? 'collapsed' : ''}`}
          onClick={toggleSidebar}
        >
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      )}

      <div className={`superadmin-panel ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="superadmin-panel-header">
  <div className="panel-header-overlay">
    {!isCollapsed && <span className="header-title">Super Admin Panel</span>}
  </div>
</div>


        <div className="superadmin-list">
          <button
            className={activePath === `/superadmin/${superAdminId}/dashboard` ? 'active' : ''}
            onClick={() => handleNavigate(`/superadmin/${superAdminId}/dashboard`)}
          >
            <img src={dashboardIcon} alt="Dashboard" className="icon" />
            {!isCollapsed && (
              <span className="superadmin-button-content">
                Dashboard <span className="superadmin-arrow">&gt;</span>
              </span>
            )}
          </button>

          <button
            className={activePath === `/superadmin/${superAdminId}/manage-modules` ? 'active' : ''}
            onClick={() => handleNavigate(`/superadmin/${superAdminId}/manage-modules`)}
          >
            <img src={modulesIcon} alt="modules" className="icon" />
            {!isCollapsed && (
              <span className="superadmin-button-content">
                Manage modules <span className="superadmin-arrow">&gt;</span>
              </span>
            )}
          </button>

         

          <button onClick={handleLogout}>
            <img src={logoutIcon} alt="Logout" className="icon" />
            {!isCollapsed && (
              <span className="superadmin-button-content">
                Logout <span className="superadmin-arrow">&gt;</span>
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminPanel;
